import XOption from 'emberx-select/components/x-option';
export default XOption;
